<template>
  <div  class="justify-content-center m-4 p-4 ">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col>
        <b-form-input size="sm"
                      placeholder="Ingresa el código"
                      v-model="codigoCupon">
        </b-form-input>
        <span style="color: #46C726; font-size: 10px" v-if="cantidadDescuento !== 0">-{{ cantidadDescuento }}% de descuento</span>
        <span style="color: rgb(255, 0, 0); font-size: 10px" v-else >{{ mensajeErrorCupon }}</span>
      </b-col>
      <b-col>
        <b-button variant="outline-info" @click="obtenerHerramientaCierreSimulacion" size="md" pill style="font-size:.7em !important; font-weight: 500">
           Aplicar
        </b-button>
      </b-col>
      <b-col>
        <span style="font-size: 10px"> Total de inversión:</span>
        <span style="font-size: 12px; font-weight: 500; color: #0069A9 "> {{ totalInversion | monedaEntero }} </span>
      </b-col>

    </b-row>

    <div>
      <b-row>
        <b-col class="text-center textSize">
          <br/>
          <br/>
          <br/>
          <span v-if="!noAplica" style="font-size: 12px; color: #929292">Ingresa la herramienta de cierre para continuar</span>
          <div v-else>
             <span style="font-size: 12px; color: #0069A9 "> Inversión final: </span>
              <span style="font-size: 12px; color: #0069A9 ">{{(totalInversion - descuentoTotalCupon) | monedaEntero  }}</span>
              <br/>

              <span style="font-size: 12px; font-weight: 500; color: #46C726 "> Descuento: </span>
              <span style="font-size: 12px; font-weight: 500; color: #46C726 " v-if="descuentoTotalCupon === 0">
                {{ 0 | monedaEntero }}
              </span>
              <span style="font-size: 12px; font-weight: 500; color: #46C726 " v-else>
                {{descuentoTotalCupon | monedaEntero}}
              </span>
          </div>
        </b-col>
      </b-row>
    </div>


  </div>
</template>
<script>
export default {
  name: "HerramientaCierrePF",
  props: {
    totalInversion: Number,
    tratamientosInversion: Array,
    idPaciente: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    codigoCupon: null,
    datosCupon: null,
    mensajeErrorCupon: "",
    descuentoTotalCupon: 0,
    noAplica: false,
    cantidadDescuento: 0

  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerHerramientaCierreSimulacion() {
      const params = {
        montoPagar: this.totalInversion,
        idPaciente: this.idPaciente,
        codigo: this.codigoCupon
      }

      this.$http.post(this.$api + "cupon/obtenerHerramientaCierreSimulacion", params).then(respuesta => {
        if (respuesta.data.data) {
          this.noAplica = true
          this.datosCupon = respuesta.data.data;

          if (this.datosCupon.msjExito) {
            this.mensajeErrorCupon = "";
            this.cantidadDescuento = this.datosCupon.cantidadDescuento;

            // Tipo de aplicacion a CUENTA
            if (this.datosCupon.tipoAplicacionDescuento === 1) {
              if (this.datosCupon.tipoDescuento === 1) { // Porcentaje
                this.descuentoTotalCupon = Math.ceil(this.totalInversion * this.datosCupon.cantidadDescuento / 100);
              } else { // Efectivo
                this.descuentoTotalCupon = this.datosCupon.cantidadDescuento;
              }
            }

            //Tipo de aplicacion a TX
            else {
              if (this.datosCupon.tipoDescuento === 1) { // Porcentaje
                let montoDescuento = 0;

                this.tratamientosInversion.forEach(txInversion => {
                  if (this.datosCupon.idsTratamientos.some(ids => ids === txInversion.idTratamiento)) {
                    txInversion.tratamientos.forEach(tx => {
                      if (tx.precioUnitario > 0) {
                        montoDescuento += Math.ceil((tx.cantidadAceptada * tx.precioUnitario) * this.datosCupon.cantidadDescuento / 100);
                      }
                    })
                  }
                })

                this.descuentoTotalCupon = montoDescuento;
              }

              // Efectivo
              else {
                let montoDescuento = 0;

                this.tratamientosInversion.forEach(txInversion => {
                  if (this.datosCupon.idsTratamientos.some(ids => ids === txInversion.idTratamiento)) {
                    txInversion.tratamientos.forEach((tx) => {
                      if (this.datosCupon.cantidadDescuento < (tx.cantidadAceptada * tx.precioUnitario)) {
                        montoDescuento += this.datosCupon.cantidadDescuento;
                      } else {
                        montoDescuento += tx.precioUnitario;
                      }
                    })
                  }
                })

                this.descuentoTotalCupon = montoDescuento;
              }
            }
          } else {
            this.mensajeErrorCupon = this.datosCupon.mensajeDeError;
          }

        }
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>
<style scoped>

</style>